import { gql } from '@apollo/client'

const LOCATION_TYPE_NODE_FRAGMENT = gql`
  fragment LocationTypeNodeFragment on LocationTypeNode {
    id
    name
    isCurationEnabled
    level
    idPath
    namePath
    type
    parentId
    position

    replaces {
      id
      name
      isCurationEnabled
      idPath
      namePath
      parentId
      type
      level
      position

      replaceToken
    }

    replacedBy {
      id
      name
      isCurationEnabled
      idPath
      namePath
      parentId
      type
      level
      position

      replaceToken
    }
  }
`

export default LOCATION_TYPE_NODE_FRAGMENT
